import { usePartnerRepository } from '@ayocore/erp/crm/client/rpc';
import { createRepositoryFilter } from '@ayocore/platform/client/components/RepositoryTable/createRepositoryFilter';
import type { DealRepository } from '@ayocore/erp/crm/server/repositories/DealRepository';

type PartnerRepo = ReturnType<typeof usePartnerRepository>;

/**
 * Фильтр сделок по партнёру (single, серверный поиск).
 * Лейбл выбранного из URL партнёра дотягивается по id (ensureValues в ядре),
 * поэтому показывается имя, а не голый id — даже если партнёр вне первых загруженных.
 */
export const FilterByPartner = createRepositoryFilter<DealRepository, PartnerRepo>({
  name: 'partner',
  placeholder: 'Партнер...',
  width: 250,
  dropdownWidth: 300,
  source: () => usePartnerRepository(),
  displayField: 'name',
  by: (repo, id) => repo.filterByPartner(id),
});
